module.exports = __webpack_public_path__ + "img/icons for DS Logistik SPIM.-12.9ee8b573.svg";